/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dialog } from "@mui/material";
import { useSnapshot } from "valtio";

import React from "react";

import { kioskStore } from "@pages/Kiosk/store";

import Footer from "./Footer";
import GiftSection from "./GiftSection";
import Header from "./Header";
import { PromoCodeSection } from "./PromoSection";
import RewardSection from "./RewardSection";

function LoyaltyStep(): JSX.Element {
    const {
        isCustomerBenefitOpen,
        isPrm,
        project: {
            template: {
                pages: {
                    subSteps: {
                        customerBenefit: {
                            options: {
                                gifts: { active: giftsActive },
                                rewards: { active: rewardsActive },
                            },
                        },
                    },
                },
            },
        },
    } = useSnapshot(kioskStore);
    const [isPrmPromoModelOpen, setIsPrmPromoModelOpen] = React.useState(false);
    const [prmSectionDisplay, setPrmSectionDisplay] = React.useState({
        isPrmReward: giftsActive ? false : rewardsActive,
        isPrmGift: giftsActive,
    });

    function computeDisplayHeight() {
        return prmSectionDisplay.isPrmReward && isPrm
            ? "155%"
            : !rewardsActive && isPrm
            ? "162%"
            : isPrm
            ? "167%"
            : "100%";
    }

    return (
        <Dialog
            open={isCustomerBenefitOpen}
            container={() => document.querySelector(".fullscreen")}
            PaperProps={{
                sx: {
                    width: "93%!important",
                    height: "max-content!important",
                    boxShadow: "0px 3px 6px #00000029!important",
                    border: "1px solid #707070!important",
                    borderRadius: "4rem",
                    maxWidth: "unset!important",
                    paddingTop: "25px!important",
                    paddingBottom: "25px!important",
                    display: "flex",
                    justifyContent: "start",
                    maxHeight: "unset",
                    alignItems: "center!important",
                },
            }}
            style={{
                backdropFilter: "blur(5px)",
                height: computeDisplayHeight(),
            }}
        >
            <Header />
            {!isPrm || (isPrm && prmSectionDisplay.isPrmGift) ? (
                <GiftSection />
            ) : null}
            {!isPrm || (isPrm && prmSectionDisplay.isPrmReward) ? (
                <RewardSection />
            ) : null}
            {isPrm && isPrmPromoModelOpen ? (
                <PromoCodeSection
                    isPromoModelOpen={isPrmPromoModelOpen}
                    setIsPromoModelOpen={setIsPrmPromoModelOpen}
                />
            ) : null}
            <Footer
                setPrmSectionDisplay={setPrmSectionDisplay}
                prmSectionDisplay={prmSectionDisplay}
                setIsPrmPromoModelOpen={setIsPrmPromoModelOpen}
            />
        </Dialog>
    );
}

export default LoyaltyStep;
